import { 
  getWebStoryListLoading,
  getWebStoryListSuccess,
  getWebStoryListFailure,

  getWebStoryFilterEntityNameLoading,
  getWebStoryFilterEntityNameSuccess,
  getWebStoryFilterEntityNameFailure,

  getWebStoryFilterEntityTypeLoading,
  getWebStoryFilterEntityTypeSuccess,
  getWebStoryFilterEntityTypeFailure,

  getWebStoryFilterWebstoryTitleLoading,
  getWebStoryFilterWebstoryTitleSuccess,
  getWebStoryFilterWebstoryTitleFailure,

  getWebStoryFilterLoading,
  getWebStoryFilterSuccess,
  getWebStoryFilterFailure,

  getWebStoryAddEditLoading,
  getWebStoryAddEditSuccess,
  getWebStoryAddEditFailure,

  putWebStoryAddEditLoading,
  putWebStoryAddEditSuccess,
  putWebStoryAddEditFailure,

  getWebStoryEntityFilterLoading,
  getWebStoryEntityFilterSuccess,
  getWebStoryEntityFilterFailure,

  postWebStoryEntityFilterLoading,
  postWebStoryEntityFilterSuccess,
  postWebStoryEntityFilterFailure,

  deleteWebStoryEntityFilterLoading,
  deleteWebStoryEntityFilterSuccess,
  deleteWebStoryEntityFilterFailure,
} from "../../slices/webStory";

  import {getWebStoryFilterRepo, getWebStorylistRepo, getWebStoryAddEditRepo , putWebStoryRepo ,getEntityFilterRepo ,postEntityFilterRepo ,deleteEntityFilterRepo} from '../../repositories/articleApp/articleApp';


  export const getWebStoryFilter = (params) => {
    return async (dispatch) => {
      dispatch(getWebStoryFilterLoading());
      try {
        const response = await getWebStoryFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getWebStoryFilterSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getWebStoryFilterFailure(error.message));
        }
      }
    };
  };

  export const getWebStoryFilterEntityName = (params) => {
    return async (dispatch) => {
      dispatch(getWebStoryFilterEntityNameLoading());
      try {
        const response = await getWebStoryFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getWebStoryFilterEntityNameSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getWebStoryFilterEntityNameFailure(error.message));
        }
      }
    };
  };


  export const getWebStoryFilterEntityType = (params) => {
    return async (dispatch) => {
      dispatch(getWebStoryFilterEntityTypeLoading());
      try {
        const response = await getWebStoryFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getWebStoryFilterEntityTypeSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getWebStoryFilterEntityTypeFailure(error.message));
        }
      }
    };
  };


  export const getWebStoryFilterWebstoryTitle = (params) => {
    return async (dispatch) => {
      dispatch(getWebStoryFilterWebstoryTitleLoading());
      try {
        const response = await getWebStoryFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getWebStoryFilterWebstoryTitleSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getWebStoryFilterWebstoryTitleFailure(error.message));
        }
      }
    };
  };

    export const getWebStoryList = (params) => {
      return async (dispatch) => {
        dispatch(getWebStoryListLoading());
        await getWebStorylistRepo(params)
          .then((response) => {
            if (response?.status == 200) {
              dispatch(getWebStoryListSuccess(response?.data?.data));
            }
          })
          .catch((error) => {
            if (error && error.response) {
              dispatch(getWebStoryListFailure(error.message));
            }
          });
      };
    };

    export const getWebStoryAddEdit = (params) => {
      return async (dispatch) => {
        dispatch((getWebStoryAddEditLoading));
        await getWebStoryAddEditRepo(params)
          .then((response) => {
            if (response?.status == 200) {
              dispatch(getWebStoryAddEditSuccess(response?.data?.data));
            }
          })
          .catch((error) => {
            if (error && error.response) {
              dispatch(getWebStoryAddEditFailure(error.message));
            }
          });
      };
    };

  export const putWebStoryAddEdit = ({ id, data }) => {
    return async (dispatch) => {
      dispatch(putWebStoryAddEditLoading());
      try {
        const response = await putWebStoryRepo(id, data);

        if (response?.status === 200) {
          dispatch(putWebStoryAddEditSuccess(response?.data?.data));
        }

        return response; 
      } catch (error) {
        dispatch(putWebStoryAddEditFailure(error?.response?.data?.message || error.message));
        throw error; 
      }
    };
  };

  export const getEntityFilter = (params) => {
    return async (dispatch) => {
      dispatch(getWebStoryEntityFilterLoading()); // ✅ add parentheses
      await getEntityFilterRepo(params)
        .then((response) => {
          if (response?.status === 200) {
            dispatch(getWebStoryEntityFilterSuccess(response?.data?.data)); // ✅
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getWebStoryEntityFilterFailure(error.message)); // ✅
          }
        });
    };
  };
  

  export const deleteEntityFilter = (data) => {
    return async (dispatch) => {
        dispatch(deleteWebStoryEntityFilterLoading());
        await deleteEntityFilterRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(deleteWebStoryEntityFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteWebStoryEntityFilterFailure(error.message));
                }
            });
    };
};

export const postEntityFilter = (data) => {
  return async (dispatch) => {
      dispatch(postWebStoryEntityFilterLoading());
      await postEntityFilterRepo (data)
          .then((response) => {
              if (response?.status >= 200 && response?.status <= 300) {
                  dispatch(postWebStoryEntityFilterSuccess(response?.data?.data));
              }
          })
          .catch((error) => {
              if (error && error.response) {
                  dispatch(postWebStoryEntityFilterFailure(error.message));
              }
          });
  };
};

    



    
    